export default __webpack_public_path__ + "static/ToppersPizza-8a2f16fc848b2fc87d6da8f8e0d4dd52.png";